import React from 'react';
import slideLoader from '../utilities/slideLoader';
import { navigationDelegate } from '../utilities/navigationDelegate';
import { heightDelegate } from '../utilities/heightDelegate';
import { LayoutManager } from '../utilities/layoutManager';

//splitviewの開閉を管理する

export default class SlideView extends React.Component {
  constructor(props) {
    super(props);

    //呼び出されたスライドのクラス名をステートに持つ
    this.state = {
      view: null,
      callback: {},
    };

    //スライド呼び出し
    slideLoader.setDelegate((view, state, vw) => {
      //開閉を分岐
      if (view) {
        this.slideMount();
      } else {
        this.slideUnMount();
      }

      if (this.props.vw == vw) {
        this.setState({
          view,
          state,
          vw,
        });
      }
    });
  }

  /**
   * スライドをマウント
   */
  slideMount() {
    //console.log("Slide Mounted !!");
    var _naviDelegate = new navigationDelegate();
    _naviDelegate.init();
    var _heightDelegate = new heightDelegate();
    _heightDelegate.initEvent();

    setTimeout(() => {
      //スクロール高さを固定
      this.layout = new LayoutManager();
      this.layout.init();
      this.layout.setNavigationDelegate(_naviDelegate);
      this.layout.setHeightDelegate(_heightDelegate);
      this.layout.setHeightUpdateElement(
        `.sys-splitview-${this.props.vw} .slide-view__body`
      );
      _naviDelegate.forceUpdate();
      _heightDelegate.forceUpdate();
      this.layout.forceUpdate();
    }, 500);
  }

  /**
   * スライドをアンマウント
   */
  slideUnMount() {
    //console.log("Slide UnMounted !!");
  }

  /**
   * ダイアログ表示
   */
  slide() {
    if (this.state.view) {
      const _view = this.state.view;
      return <_view view={this.state.state} vw={this.state.vw} />;
    }
    return <div />;
  }

  render() {
    const viewshow = () => {
      return this.state.view ? 'slide-view show' : 'modal';
    };
    return <div className={viewshow()}>{this.slide()}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/slideView.js